<template>
  <BaseModal @outside="emits('close')">
    <div class="lost-focus-modal">
      <img
        class="close-btn"
        src="@/assets/icon/close.svg"
        alt="modal-close-icon"
        @click="emits('close')"
      />

      <img :src="banner" alt="" />
      <p class="text-center">
        加入美業歐巴的 LINE 官方帳號，<br />
        讓美業歐巴為您打造專屬的 Social CRM！
      </p>
      <a
        href="https://lin.ee/Gh2sAiI"
        target="_blank"
        rel="noreferrer noopener"
      >
        <div class="primary-btn px-20px py-12px m-auto w-fit !rounded-[8px]">
          立即加入
        </div>
      </a>
    </div>
  </BaseModal>
</template>

<script setup>
import BaseModal from '@/components/BaseModal.vue'
import banner from '@/assets/lost_focus_modal/banner.webp'

const emits = defineEmits(['close'])
</script>

<style scoped lang="postcss">
.lost-focus-modal {
  @apply bg-white p-20px rounded-24px;
  @apply flex flex-col gap-16px;
  @apply mx-12px;
  @apply relative;
}

.close-btn {
  @apply absolute top-4 right-4;
  @apply cursor-pointer;
}
</style>
